export default {
  currentContainer: null,
  device: "desktop",

  checkoutBuilder: {},

  element: "",
  editing: true,

  background: {},
  components: [],

  snapshots: []
};
